module.exports = __webpack_public_path__ + "img/pursuit-detection-photo.5765d6f3.png";